import {CheckboxAlone} from 'plugins/modules/filter/components/CheckboxAlone';
import {CheckboxAloneCustom} from 'plugins/modules/filter/components/CheckboxAloneCustom';
import {FilterCustomViewType, IFilterFacet} from 'plugins/modules/filter/types';
import React, {FC, useCallback} from 'react';
import {Chips} from 'plugins/modules/filter/components/Chips';
import style from './style.module.scss';

interface IProps {
    filter: IFilterFacet;
    onApply: () => void;
    onDiscard: () => void;
}

export const CheckboxAloneFactory: FC<IProps> = ({filter, onApply, onDiscard}) => {
    const handleChange = useCallback(
        (isChecked: boolean) => {
            if (isChecked) {
                onApply();

                return;
            }

            onDiscard();
        },
        [onApply, onDiscard],
    );

    const {customView, hint, isApplied, title} = filter;

    if (customView === FilterCustomViewType.ART || customView === FilterCustomViewType.GIFT) {
        return (
            <div className={style.aloneCustom}>
                <CheckboxAloneCustom
                    hint={hint}
                    isDefaultChecked={isApplied}
                    onChange={handleChange}
                    title={title}
                    view={customView}
                />
            </div>
        );
    }

    if (customView === FilterCustomViewType.CHIPS) {
        const count = filter.variants?.[0]?.count;
        return count ? (
            <div className={style.chips}>
                <Chips
                    count={filter.variants?.[0]?.count}
                    isDefaultChecked={isApplied}
                    onChange={handleChange}
                    title={`${filter.variants?.[0]?.title || title}`}
                />
            </div>
        ) : null;
    }

    return <CheckboxAlone hint={hint} isDefaultChecked={isApplied} onChange={handleChange} title={title} />;
};
